var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-fb",
    "data-name": "icon-fb",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.11 24.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fb-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fb-cls-1",
    d: "M15.22,5H19V.44H15.22a5.31,5.31,0,0,0-5.3,5.3V8h-3v4.54h3V24.67h4.54V12.55h3.79L19,8H14.46V5.74A.77.77,0,0,1,15.22,5Z",
    transform: "translate(-6.89 -0.44)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocFb);
export default __webpack_public_path__ + "static/media/soc-fb.2c7aa2ba0d862483f09b957a5fb01d36.svg";
export { ForwardRef as ReactComponent };